import { Component, OnInit } from "@angular/core";
import { TCITenantSelectorType } from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../ng-tenant/tci-tenant-component";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_CONNECTIONS.toString(),
    template: "<div><h1>BASE APP CONNECTIONS</h1></div>"
})
export class BaseAppDetailConnectionsComponent
    <E, I extends BaseAppDetailMenuComponentInput, O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit {
    constructor() {
        super();
    }

    ngOnInit(): void {
    }
}
